var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ClientService from '../../api/ClientService';
import _ from 'lodash';
import Pager from '../../common/Pager';
var LIMIT = 25;
var ClientGoodsList = (function (_super) {
    __extends(ClientGoodsList, _super);
    function ClientGoodsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.page = new Pager().setLimit(LIMIT);
        _this.categoryList = [];
        _this.tableHeight = 300;
        _this.isFirst = true;
        _this.statusList = [
            { name: '全部', value: 0 },
            { name: '已绑定', value: 1 },
            { name: '未绑定', value: 2 }
        ];
        _this.formData = {
            text: '',
            clients: null,
            supplier_to_business_ids: null,
            bind_status: 0
        };
        return _this;
    }
    ClientGoodsList.prototype.normalizer = function (node) {
        return {
            id: node.supplier_to_business_id,
            label: node.business_name,
            children: node.children,
        };
    };
    ClientGoodsList.prototype.listDataWatch = function () {
        var _this = this;
        if (this.listData.length && this.good_code && this.isFirst) {
            this.$nextTick(function () {
                _this.$refs.grid.toggleRowSelection(_this.listData[0], true);
            });
            this.isFirst = false;
        }
        if (this.listData.length <= LIMIT) {
            this.$refs.grid.bodyWrapper.scrollTop = 0;
        }
    };
    ClientGoodsList.prototype.watch_isInitPage = function () {
        this.search();
    };
    ClientGoodsList.prototype.created = function () {
        var _this = this;
        if (this.good_code) {
            this.formData.text = this.good_code;
        }
        this.service = ClientService.getInstance();
        this.service.getClientsByGroup().then(function (res) {
            var data = res.data;
            var list = data.data;
            list.forEach(function (item, index) {
                item.business_id = new Date().getTime() + index;
                item.business_name = item.group_name;
                item.supplier_to_business_id = new Date().getTime() + index;
            });
            _this.categoryList = list;
            _this.formData.clients = _this.clientIds.split(',')[0];
            _this.formData.supplier_to_business_ids = _this.supplierToBusinessIds.split(',')[0];
            _this.$emit('search', _this.getSearchParams());
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ClientGoodsList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
        this.$refs.grid.$refs.bodyWrapper.addEventListener('scroll', _.throttle(this.gridScroll.bind(this), 100));
    };
    ClientGoodsList.prototype.gridScroll = function (e) {
        var scrollHeight = e.target.scrollHeight;
        if (scrollHeight - e.target.clientHeight - e.target.scrollTop < scrollHeight * 0.01) {
            if (this.currentCount >= LIMIT) {
                this.page.setNext();
                this.$emit('search', this.getSearchParams());
            }
        }
    };
    ClientGoodsList.prototype.getSearchParams = function () {
        var params = {
            business_id: this.formData.clients,
            supplier_to_business_id: this.formData.supplier_to_business_ids,
            key_name: this.formData.text,
            bind_status: this.formData.bind_status
        };
        return Object.assign({}, params, this.page);
    };
    ClientGoodsList.prototype.clientSelect = function (node) {
        this.formData.supplier_to_business_ids = node.supplier_to_business_id;
        this.formData.clients = node.business_id;
        this.search();
    };
    ClientGoodsList.prototype.search = function () {
        this.page.clear().setLimit(LIMIT);
        this.$emit('search', this.getSearchParams());
    };
    ClientGoodsList.prototype.selectionChange = function (rows) {
        this.$emit('selectGoods', rows);
    };
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], ClientGoodsList.prototype, "clientIds", void 0);
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], ClientGoodsList.prototype, "supplierToBusinessIds", void 0);
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], ClientGoodsList.prototype, "good_code", void 0);
    __decorate([
        Prop({
            default: [],
            type: Array
        })
    ], ClientGoodsList.prototype, "listData", void 0);
    __decorate([
        Prop({
            default: 0,
            type: Number
        })
    ], ClientGoodsList.prototype, "currentCount", void 0);
    __decorate([
        Prop({
            default: false,
            type: Boolean
        })
    ], ClientGoodsList.prototype, "isInitPage", void 0);
    __decorate([
        Watch("listData")
    ], ClientGoodsList.prototype, "listDataWatch", null);
    __decorate([
        Watch("isInitPage")
    ], ClientGoodsList.prototype, "watch_isInitPage", null);
    ClientGoodsList = __decorate([
        Component
    ], ClientGoodsList);
    return ClientGoodsList;
}(Vue));
export default ClientGoodsList;
